function stackPositions() {
    const vh = window.innerHeight;

    document.querySelectorAll(".js-stack").forEach(stack => {
        const stackHeight = stack.offsetHeight;
        const topValue = stackHeight > vh ? vh - stackHeight : 0;

        stack.style.top = `${topValue}px`;
    });
}

export default class StackComponent {
    init() {
        stackPositions();
    }

    onResize() {
        stackPositions();
    }
}
